import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { canAccessPanelPath, isAdminRole } from "../utils/roles";

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** If true, only admin may render this route. */
  adminOnly?: boolean;
}

/**
 * Requires login. Optionally restricts to admin.
 * Staff/dealer hitting admin URLs are sent to /panel/orders.
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  adminOnly = false,
}) => {
  const location = useLocation();
  const { authToken, id, role } = useSelector((state: any) => state.loginData || {});

  if (!authToken || !id) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdminRole(role)) {
    return <Navigate to="/panel/orders" replace />;
  }

  if (!canAccessPanelPath(role, location.pathname)) {
    return <Navigate to="/panel/orders" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
